import React from 'react'
import {numberFormat} from '../../utils/Functions'
import {includes} from 'lodash'
import {useSearchParams} from 'react-router-dom'
import {IncomeDocumentTypes} from '../../constants/Common'

interface IExpenseAccountOrderSummary {
  document?: any
  productPriceInfo: any
  linkingDocument?: any
  previousItems?: any[]
  excludeField?: string[]
  vatType?: string
  isInForm?: boolean
  isInCreditDebit?: boolean
  docType?: string
  paymentsLength?: number
}

const ExpenseAccountOrderSummary: React.FC<IExpenseAccountOrderSummary> = (props) => {
  const {
    document,
    productPriceInfo,
    vatType,
    excludeField = [],
    previousItems = [],
    isInForm,
    isInCreditDebit,
    docType,
    paymentsLength,
    linkingDocument,
  } = props
  console.log({productPriceInfo})

  const isExpenseRecord = docType === IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD
  const isInvertoryRecord = docType === IncomeDocumentTypes.EXPENSE_PURCHASE_INVENTORY_RECORD
  const isCombined = docType === IncomeDocumentTypes.EXPENSE_COMBINED_PAYMENT_NOTE
  const isCredit = docType === IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
  const isDebit = docType === IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE
  const isDepositPayment = docType === IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT
  const {
    // totalPaymentDepositBillAmount,
    // totalCreditNoteBillAmount,
    // totalPaymentDepositVatAmount,
    // totalCreditNoteVatAmount,
    // totalPaymentDepositWhTaxPriceAmount,
    // totalCreditNoteWhTaxPriceAmount,
    totalBillAmount,
    totalVatAmount,
    totalWhTaxPriceAmount,
    // totalDecreaseWhTaxPriceAmount,
    totalDecreaseBillAmount,
    // totalDecreaseVatAmount,
  } = productPriceInfo?.comBinedData || {}

  // คำนวณมูลค่าตามเอกสารเดิมจาก previousItems
  const calculatePreviousTotal = () => {
    // console.log(343343443, previousItems)
    // console.log(343343443, {linkingDocument})

    return previousItems.reduce((sum, item) => {
      const itemPrice = item.pricePerUnit * item.quantity
      return sum + itemPrice
    }, 0)
  }

  // คำนวณมูลค่าที่ถูกต้อง (ถ้ามี previousItems จะคำนวณจากการปรับปรุง)
  const calculateCorrectPrice = () => {
    let previousTotal = calculatePreviousTotal()
    // console.log({previousTotal})

    // console.log({previousTotal})
    // console.log({productPriceInfo})
    // console.log({isInForm})
    // console.log({isCredit})
    // console.log({isDebit})
    if (previousTotal > 0) {
      const debitDetailForm = Math.abs(
        productPriceInfo.vatTotal
          ? productPriceInfo.vatItemPriceTotal || 0
          : productPriceInfo.noVatItemPriceTotal || 0
      )
      const creditDetailForm = Math.abs(
        productPriceInfo.vatTotal
          ? productPriceInfo.vatItemPriceTotal || 0
          : productPriceInfo.noVatItemPriceTotal || 0
      )

      return isCredit ? previousTotal - debitDetailForm : previousTotal + creditDetailForm
    }
    return null
  }
  // console.log(6565655, productPriceInfo)

  const previousTotal =
    productPriceInfo?.beforeCorrectPrice >= 0
      ? productPriceInfo?.beforeCorrectPrice
      : calculatePreviousTotal()
  const correctPrice =
    productPriceInfo?.correctPrice >= 0 ? productPriceInfo?.correctPrice : calculateCorrectPrice()

  // console.log({correctPrice})
  const documentPaymentsLength =
    typeof paymentsLength === 'number'
      ? paymentsLength
      : document
      ? document?.incomeDocumentPayments?.length
      : 0

  // console.log(42154377)
  // console.log({totalBillAmount})
  // console.log({totalWhTaxPriceAmount})
  // console.log({productPriceInfo})

  // const combinedRemaining =
  //   totalBillAmount -
  //   totalWhTaxPriceAmount -
  //   productPriceInfo.paidAmount -
  //   productPriceInfo.paymentDeductionsAmount -
  //   productPriceInfo.paymentFeeAmount

  const remainAmount = isInForm
    ? productPriceInfo.subTotal
    : !documentPaymentsLength
    ? !productPriceInfo?.paymentCombinedAmount
      ? productPriceInfo.total -
        (!isInForm && productPriceInfo.whTaxTotal > 0 ? productPriceInfo.whTaxTotal : 0)
      : productPriceInfo.remainingAmount
    : productPriceInfo.remainingAmount
  // console.log({remainAmount})
  // console.log({documentPaymentsLength})
  // console.log({productPriceInfo})

  const paidAmount =
    (productPriceInfo?.paidAmount || 0) +
    (!isCredit && !isDebit && typeof productPriceInfo.paymentCombinedAmount === 'number'
      ? (productPriceInfo?.paymentCombinedAmount || 0) - (productPriceInfo?.paidWhTaxPrice || 0)
      : 0)

  return (
    <div>
      <div className={'d-flex justify-content-end text-end'}>
        <div className={'d-flex flex-column align-items-end'}>
          {productPriceInfo?.depositTotal > 0 && (
            <>
              {vatType && ['included', 'excluded']?.includes(vatType) && (
                <span>({vatType === 'included' ? 'รวมภาษี' : 'แยกภาษี'})</span>
              )}
              <div className={'d-flex justify-content-end'}>
                <span>มูลค่าก่อนหักเงินมัดจำ</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo?.beforeDepositTotal, false, '0', true)}
                </strong>
                <span>บาท</span>
              </div>
              <div className={'d-flex justify-content-end'}>
                <span>เงินมัดจำรวม</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo?.depositTotal, false, '0', true)}
                </strong>
                <span>บาท</span>
              </div>
            </>
          )}

          {!includes(excludeField, 'discountTotal') && productPriceInfo?.discountTotal > 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>ส่วนลดรวม</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.discountTotal, false, '0', true)}
              </strong>
              <span>บาท</span>
            </div>
          )}

          {productPriceInfo?.depositTotal > 0 && (
            <div className={'d-flex justify-content-end mb-3'}>
              <span>มูลค่าหลังหักมัดจำ</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(
                  productPriceInfo?.beforeDepositTotal - productPriceInfo?.depositTotal,
                  false,
                  '0',
                  true
                )}
              </strong>
              <span>บาท</span>
            </div>
          )}

          {/* แสดงมูลค่าตามเอกสารเดิม เมื่อมี previousItems */}
          {previousTotal > 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>มูลค่าตามเอกสารเดิม</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(previousTotal, false, '0', true)}
              </strong>
              <span>บาท</span>
            </div>
          )}

          {/* แสดงมูลค่าที่ถูกต้อง เมื่อคำนวณได้ */}
          {correctPrice !== null && (
            <div className={'d-flex justify-content-end'}>
              <span>มูลค่าที่ถูกต้อง</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(correctPrice, false, '0')}
              </strong>
              <span>บาท</span>
            </div>
          )}

          {typeof productPriceInfo.paymentDeductionsAmount === 'number' && (
            <div className={'d-flex justify-content-end my-2'}>
              <span>มูลค่าที่ตัดชำระกับเอกสาร</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {productPriceInfo.paymentDeductionsAmount < 0
                  ? `(${numberFormat(productPriceInfo.paymentDeductionsAmount, false, '0', true)})`
                  : numberFormat(productPriceInfo.paymentDeductionsAmount, false, '0', true)}
              </strong>
              <span>บาท</span>
            </div>
          )}
          {!isCredit && !isDebit && typeof productPriceInfo.paymentCombinedAmount === 'number' && (
            <div className={'d-flex justify-content-end my-2'}>
              <span>มูลค่าที่นำไปจ่ายในใบรวม</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.paymentCombinedAmount, false, '0', true)}
              </strong>
              <span>บาท</span>
            </div>
          )}

          <div className={'d-flex justify-content-end mt-2'}>
            <span>มูลค่าไม่มีหรือยกเว้นภาษี</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.noVatItemPriceTotal, false, '0', true)}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>มูลค่าที่คำนวณภาษี 0%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.zeroVatItemPriceTotal, false, '0', true)}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>มูลค่าที่คำนวณภาษี 7%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(
                isCombined ? totalBillAmount - totalVatAmount : productPriceInfo.vatItemPriceTotal,
                false,
                '0',
                true
              )}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>ภาษีมูลค่าเพิ่ม 7%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(
                (isCombined ? totalVatAmount : productPriceInfo.vatTotal) +
                  (productPriceInfo?.paymentDeductionsVatPrice || 0),
                false,
                '0',
                true
              )}
            </strong>
            <span>บาท</span>
          </div>

          {!isInForm && productPriceInfo.whTaxTotal > 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>ภาษีหัก ณ ที่จ่ายที่ต้องชำระ</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.whTaxTotal)}
              </strong>
              <span>บาท</span>
            </div>
          )}
        </div>
        <div className={'d-flex flex-column align-items-end ms-5 ps-5'}>
          <div className={'d-flex align-items-end bg-primary py-3 px-5 rounded text-white mb-4'}>
            <span>จำนวนเงินทั้งสิ้น</span>
            <span className={'h1 mb-0 ps-5 pe-3 text-white'} style={{minWidth: 150}}>
              {numberFormat(
                (isCombined
                  ? totalBillAmount
                  : (isExpenseRecord || isInvertoryRecord) && productPriceInfo?.depositTotal
                  ? productPriceInfo.beforeDepositTotal - productPriceInfo.depositTotal
                  : productPriceInfo.total) +
                  (typeof productPriceInfo.paymentDeductionsAmount === 'number'
                    ? productPriceInfo.paymentDeductionsAmount < 0
                      ? Math.abs(productPriceInfo?.paymentDeductionsAmount || 0)
                      : -Math.abs(productPriceInfo?.paymentDeductionsAmount || 0)
                    : 0)
              )}
            </span>
            <span>บาท</span>
          </div>
          {productPriceInfo.total !== 0 && (
            <div>
              {!!isInForm && productPriceInfo.whTaxTotal > 0 && (
                <div className={'d-flex justify-content-end'}>
                  <span>จำนวนเงินที่ถูกหัก ณ ที่จ่าย</span>
                  <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                    {numberFormat(productPriceInfo.whTaxTotal)}
                  </strong>
                  <span>บาท</span>
                </div>
              )}

              {/* แสดงภาษีหัก ณ ที่จ่ายที่ชำระแล้ว หากมี */}

              {!isInForm && (
                <div className={'d-flex justify-content-end'}>
                  <span>ภาษีหัก ณ ที่จ่ายที่ชำระแล้ว</span>
                  <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                    {numberFormat(productPriceInfo.paidWhTaxPrice)}
                  </strong>
                  <span>บาท</span>
                </div>
              )}

              {/* {isCombined && totalWhTaxPriceAmount > 0 && (
                <div className={'d-flex justify-content-end'}>
                  <span>ภาษีหัก ณ ที่จ่ายที่ชำระแล้ว</span>
                  <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                    {numberFormat(totalWhTaxPriceAmount)}
                  </strong>
                  <span>บาท</span>
                </div>
              )} */}

              {/* แสดงยอดที่ชำระแล้ว หากมีการชำระ */}
              <div className={'d-flex justify-content-end'}>
                <span>จำนวนเงินที่ชำระแล้ว</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(paidAmount >= 0 ? paidAmount : 0)}
                </strong>
                <span>บาท</span>
              </div>

              {!!productPriceInfo.paymentFeeAmount &&
                typeof productPriceInfo.paymentFeeAmount === 'number' && (
                  <div className={'d-flex justify-content-end mt-1'}>
                    <span>ปรับปรุงรวม</span>
                    <span className={'h4 ps-5 pe-3 mb-0'} style={{minWidth: 150}}>
                      {isInCreditDebit && !isInForm ? (
                        <>
                          {Math.sign(productPriceInfo.paymentFeeAmount) === -1
                            ? `${numberFormat(productPriceInfo.paymentFeeAmount * -1)}`
                            : `(${numberFormat(productPriceInfo.paymentFeeAmount)})`}
                        </>
                      ) : (
                        <>
                          (
                          {Math.sign(productPriceInfo.paymentFeeAmount) === -1
                            ? `(${numberFormat(productPriceInfo.paymentFeeAmount * -1)})`
                            : numberFormat(productPriceInfo.paymentFeeAmount)}
                          )
                        </>
                      )}
                    </span>
                    <span>บาท</span>
                  </div>
                )}

              <div className={'d-flex justify-content-end'}>
                <span>จำนวนเงินที่จะต้องชำระ</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(remainAmount >= 0 ? remainAmount : 0)}
                </strong>
                <span>บาท</span>
              </div>

              {/* แสดงยอดคงเหลือ หากมีการชำระบางส่วน */}
              {/* {productPriceInfo.paidAmount > 0 &&
                productPriceInfo.remainingAmount !== productPriceInfo.subTotal && (
                  <div className={'d-flex justify-content-end border-top pt-2 mt-2'}>
                    <span>ยอดคงเหลือที่ต้องชำระ</span>
                    <strong className={'fs-4 ps-5 pe-3 text-danger'} style={{minWidth: 150}}>
                      {numberFormat(productPriceInfo.remainingAmount)}
                    </strong>
                    <span>บาท</span>
                  </div>
                )} */}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ExpenseAccountOrderSummary
